import React from 'react'
import { Routes, Route } from 'react-router-dom'
import styled from 'styled-components'
import { Layout } from 'antd'
import { SettingOutlined, FileDoneOutlined } from '@ant-design/icons'
import ConsentFormSettingPage from './ConsentFormSettingPage'
import ConsentFormRecordsPage from './ConsentFormRecordsPage'
import PillTabs from '../components/PillTabs'

const { Content } = Layout

const ManagementContainer = styled(Layout)`
  min-height: calc(100vh - 120px);
  background: #fff;
`

const TabsHeader = styled.div`
  position: sticky;
  top: 0;
  z-index: 5;
  background: linear-gradient(180deg, #ffffff 0%, #ffffff 80%, transparent 100%);
  backdrop-filter: saturate(180%) blur(8px);
  padding-bottom: 8px;
  border-bottom: 1px solid #f1f3f5;
`

const ContentWrapper = styled(Content)`
  padding: 0;
  background: transparent;
`

// 同意書主色（與堂票區隔）
const CONSENT_FORM_COLOR = '#5b8def'

const CONSENT_FORM_TABS = [
  {
    key: 'settings',
    label: '同意書設定',
    path: '/consent-form/settings',
    icon: <SettingOutlined />
  },
  {
    key: 'records',
    label: '簽署紀錄',
    path: '/consent-form/records',
    icon: <FileDoneOutlined />
  }
]

const ConsentFormManagementPage = () => {
  return (
    <ManagementContainer>
      <TabsHeader>
        <PillTabs items={CONSENT_FORM_TABS} color={CONSENT_FORM_COLOR} />
      </TabsHeader>
      <ContentWrapper>
        <Routes>
          <Route path='settings' element={<ConsentFormSettingPage />} />
          <Route path='records' element={<ConsentFormRecordsPage />} />
          <Route path='*' element={<ConsentFormRecordsPage />} />
        </Routes>
      </ContentWrapper>
    </ManagementContainer>
  )
}

export default ConsentFormManagementPage
